var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M990.3 683.5C1004.2 737.1 972 775.3 915.5 803.9C866.2 828.9 816.9 853.1 765.2 872.7C746.7 879.7 735.1 876.3 726.9 859C726.4 858.1 725.6 857.3 725.1 856.4C714.2 837.1 693.7 816.9 695.2 798.6C696.7 779.9 729.9 780.7 746.3 767.9C752.7 762.9 768.3 764.3 763.5 751.3C757.8 736 745.2 741.7 734 746.4C584.6 808.6 435 810.3 285.1 748.2C275 744 262.9 738.5 257.1 750.8C250 765.9 268.5 764.2 274.7 770.8C276.7 773 280.5 773.4 283.1 775.2C296.4 784.7 326.1 784.9 323.1 799.5C317.6 826.6 298.8 850.9 279.6 872.4C274 878.6 265.3 874.1 258.4 871.9C182.7 848 113 812.8 48.3 767.2C38.7 760.4 34.4 752.8 33.4 741.2C16.2 550.5 66.3 377.5 170 218.6C173.4 213.5 178.2 208.2 183.6 205.7C240.7 179.4 300.5 161.2 362.1 149.2C382.5 145.2 385.1 163.2 388.9 174.3C396.5 196.4 409.3 198.7 430.2 195.7C483 188.1 536.2 188.2 589 195.8C609.4 198.7 623.7 197.6 630 174.5C636 153 649 142 672.5 152.6C676.3 154.3 680.9 153.7 685 154.9C863.2 206.3 841.1 185.4 922.1 352.5C970.5 452.4 988.4 560.2 990.3 683.5ZM582.8 549.2C582.6 601.7 621.5 644.5 669.4 644.7C715.8 644.8 753.8 603.4 754.9 551.5C756.1 496 717.9 452.3 668.6 452.7C620.8 453.1 582.9 495.7 582.8 549.2ZM436.4 550.1C436.1 495.7 396.6 452.4 347.7 452.7C302.2 453 263.5 498.7 264.3 551.5C265 603.5 304.9 645.5 352.8 644.8C398.7 644.1 436.7 601 436.4 550.1Z",
    fill: "#FCFCFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordv2);
export default __webpack_public_path__ + "static/media/discordv2.7b9872dc706c677bd16183ab99dae31e.svg";
export { ForwardRef as ReactComponent };